function waitForPriceUpdate(wrapper) {
  const spinner = wrapper.querySelector('.spinner-container');
  const boldPrice = wrapper.querySelector('.bold-price');
  const priceItem = wrapper.querySelector('.price-item2');
//  const fallbackPrice = wrapper.querySelector('.price-item3');
  const fallbackPrice = wrapper.querySelector('.price-item3') || wrapper.querySelector('.price-item-fallback');


  if (!spinner || !boldPrice) return;

  const isPriceReady = () =>
    priceItem && priceItem.textContent.trim() !== '' && priceItem.offsetHeight > 0;

  const showPrice = () => {
    spinner.style.display = 'none';

    boldPrice.style.removeProperty('display');
    boldPrice.style.display = 'block';

    if (isPriceReady()) {
      if (priceItem) {
        priceItem.style.removeProperty('display');
        priceItem.style.display = 'inline-block';
      }
      if (fallbackPrice) fallbackPrice.style.display = 'none';
    } else {
      if (priceItem) priceItem.style.display = 'none';
      if (fallbackPrice) {
        fallbackPrice.style.removeProperty('display');
        fallbackPrice.style.display = 'inline-block';
       // console.warn('Fallback price displayed due to empty price-item2.');
      }
    }
  };

  // Case where item has no discount at all
  if (wrapper.classList.contains('no-discount')) {
    spinner.style.display = 'none';
    boldPrice.style.display = 'block';
    if (fallbackPrice) fallbackPrice.style.display = 'inline-block';
    return;
  }

  // Initial state
  spinner.style.display = 'inline-block';
  boldPrice.style.display = 'none';
  if (priceItem) priceItem.style.display = 'none';
  if (fallbackPrice) fallbackPrice.style.display = 'none';

  const observer = new MutationObserver(() => {
    if (isPriceReady()) {
      showPrice();
      observer.disconnect();
    }
  });

  if (priceItem) {
    observer.observe(priceItem, { childList: true, subtree: true });
  }

  // Fallback timeout if Bold doesn’t load anything
  setTimeout(() => {
    if (!isPriceReady()) {
      if (fallbackPrice) {
        fallbackPrice.style.removeProperty('display');
        fallbackPrice.style.display = 'inline-block';
        console.warn('Bold price load timeout, showing fallback.');
      }
    }
    showPrice();
    observer.disconnect();
  }, 6000);
}



  function initBoldPricing(context = document) {
    const wrappers = context.querySelectorAll('.bold-price-wrapper');
    wrappers.forEach(waitForPriceUpdate);

    if (typeof BOLD !== 'undefined' && BOLD.Price) {
      BOLD.Price.destroy(); // Clean slate
      BOLD.Price.run();     // Re-run pricing logic
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    initBoldPricing();
  });

  document.addEventListener('shopify:section:load', (e) => {
    initBoldPricing(e.target);
  });

  document.addEventListener('ajaxComplete', () => {
    initBoldPricing();
  });

  const observeNewNodes = (container) => {
    const observer = new MutationObserver(mutations => {
      const shouldReinit = mutations.some(mutation => Array.from(mutation.addedNodes).some(
        node => node.nodeType === 1 && (node.matches('.bold-price-wrapper') || node.querySelector('.bold-price-wrapper'))
      ));
      if (shouldReinit) {
        initBoldPricing(container);
      }
    });

    observer.observe(container, {
      childList: true,
      subtree: true,
    });
  };

  // Product grid on collection or filtered pages
  const productGrid = document.querySelector('.product-grid-container');
  if (productGrid) {
    observeNewNodes(productGrid);
  }

  // Global observer fallback
  observeNewNodes(document.body);

// Only run this on product pages



